import { Fragment, FunctionalComponent, h } from 'preact';
import { Suspense, lazy } from 'preact/compat';
import Usercentrics, { InitialUIValues } from '@usercentrics/cmp-browser-sdk';
import { useEmbeddings, useInitApp } from './hooks';
import FocusLock from './components/FocusLock/FocusLock';
import { StateUpdater } from 'preact/hooks';
import { Theme } from './styles';
import { VIEW } from './enums';
import usePublicMethods from './hooks/usePublicMethods';
import { useUiContext } from './contexts/UiContext';

type Props = {
  initialUIValues: InitialUIValues;
  onThemeChange: StateUpdater<Theme>;
  restartCMP: () => Promise<void>;
  UC: Usercentrics;
};

const View = lazy(() => import('./views'));

const App: FunctionalComponent<Props> = ({ initialUIValues, restartCMP, onThemeChange, UC }) => {
  const { view } = useUiContext();

  useInitApp(UC, initialUIValues, onThemeChange);
  const { acceptAllDefault, acceptAllTCF, closeCMP, denyAllDefault, denyAllTCF, updateLanguage, showSecondLayer } =
    usePublicMethods({ initialUIValues, onThemeChange, restartCMP, UC });
  useEmbeddings(UC);

  if (view === VIEW.NONE) {
    return null;
  }

  const appView = (
    <View
      acceptAllDefault={acceptAllDefault}
      acceptAllTCF={acceptAllTCF}
      denyAllDefault={denyAllDefault}
      denyAllTCF={denyAllTCF}
      onClose={closeCMP}
      onLanguageChange={updateLanguage}
      showSecondLayer={showSecondLayer}
      UC={UC}
    />
  );

  return (
    <Suspense fallback={<Fragment />}>
      {view === VIEW.FIRST_LAYER || view === VIEW.SECOND_LAYER ? <FocusLock>{appView}</FocusLock> : appView}
    </Suspense>
  );
};

export default App;
